import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
export function Nav() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.nav initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-178">
      <div className="max-w-6xl mx-auto px-6 flex justify-between items-center" data-id="element-179">
        <div className="font-playfair font-bold text-xl tracking-widest text-sky-600" data-id="element-180">
          SUGAR HACK
        </div>
        <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
        behavior: 'smooth'
      })} className="bg-orange-500 hover:bg-orange-600 text-white font-semibold py-2 px-6 rounded-full transition-colors text-sm shadow-sm" data-id="element-181">
          Get Access — $17
        </button>
      </div>
    </motion.nav>;
}